import React, {useState} from 'react'
import {FormHelperText, FormLabel, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import Button from 'components/Button';
import getObjectValue from 'libs/getObjectValue';
import SelectOrganization from "./popup/selectOrganization/SelectOrganization";

const style = theme => ({
    root: {
        marginTop: theme.spacing()
    },
    chipLabel: {
        maxWidth: 250,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    buttonSelect: {
        marginRight: theme.spacing(2)
    }
})

function OrganizationInput(
    {
        classes,
        formikProps,
        id,
        required,
        availableOrganizations,
        disabled
    }) {

    const [openSelectOrganization, setOpenSelectOrganization] = useState(false)
    const initOrganization = getObjectValue(id, formikProps.values, null);
    const handleClick = () => {
        setOpenSelectOrganization(true)
        formikProps.setFieldTouched(id, true)
    }

    const handleClosePoup = () => {
        setOpenSelectOrganization(false)
        formikProps.setFieldTouched(id, true)
    }

    const handleConfirm = (values) => {
        handleClosePoup();
        formikProps.setFieldValue(id, values)
    }

    const element = getObjectValue(id, formikProps.values, {})
    const errorValue = getObjectValue(id, formikProps.errors, '')
    const touched = getObjectValue(id, formikProps.touched, false)
    const editable = getObjectValue('_editable', formikProps.values, true);
    const errorLabel = touched && errorValue ? errorValue : ''

    return (
        <>
            <FormLabel>
                {Tr('organizational_unit')} {required && '*'}
            </FormLabel>
            <GridBlock
                className={classes.root}
                alignItems='center'
                wrap='nowrap'
            >
                {(editable && !disabled) && <Button
                    onClick={handleClick}
                    className={classes.buttonSelect}
                    disabled={!editable || disabled}
                >
                    {Tr('select')}
                </Button>}

                <GridBlock spacing={1}>
                    <Typography>{element.name}</Typography>
                </GridBlock>
            </GridBlock>
            <SelectOrganization
                initOrganization={initOrganization}
                availableOrganizations={availableOrganizations}
                open={openSelectOrganization}
                onConfirm={handleConfirm}
                onCancel={handleClosePoup}/>
            <FormHelperText error>{errorLabel}</FormHelperText>
        </>
    )
}

OrganizationInput.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(OrganizationInput);